import PictureOptionsGrid from './PictureOptionsGrid'
import { getLocalizedProductText } from './utils/productHelpers'

const ManualHairTypeSelector = ({
  options = [],
  onSelect,
  onBack,
  translations = {},
  language = 'EN',
}) => {
  return (
    <>
      <div className='upload-zone-text'>
        <strong>
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.manualHairType.title',
            fallback: 'Select your hair type',
          })}
        </strong>
        <br />
        {getLocalizedProductText({
          translations,
          language,
          keyPath: 'productFlow.manualHairType.subtitle',
          fallback: 'Choose the option that best matches your hair pattern.',
        })}
      </div>

      <PictureOptionsGrid options={options} onSelect={onSelect} />

      <button
        type='button'
        className='upload-send-btn'
        onClick={onBack}
        style={{
          marginTop: '10px',
          width: '100%',
        }}
      >
        {getLocalizedProductText({
          translations,
          language,
          keyPath: 'productFlow.manualHairType.back',
          fallback: 'Back',
        })}
      </button>
    </>
  )
}

export default ManualHairTypeSelector
